module.exports = __webpack_public_path__ + "static/media/fortlev-solar-usina-06.84b4ac12.png";